import TablePagination from "@mui/material/TablePagination";
import { makeStyles } from "@mui/styles";
import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { IoChevronUp } from "react-icons/io5";

import {
  setFilters as setStateFilters,
  setPage as setStatePage,
} from "./reducer";
import { Context } from "../../context/globalContext";
import BorderForSelectNumberOfRecords from "../BorderForSelectNumberOfRecords";
import SkeletonListItem from "../SkeletonListItem";
import { getPropostas } from "./action";
import TableComponent from "./table";
import SearchComponent from "./search";
import * as S from "./styles";
import Button from "../Button-v2";
import { GoTopoButtonWrapper } from "../../styles/commonStyle";

const useStyles = makeStyles({
  caption: {
    padding: 8,
    fontSize: "1.25rem",
  },
  toolbar: {
    "& > p:nth-of-type(2)": {
      fontSize: "1.25rem",
      color: "red",
      fontWeight: 600,
    },
  },
});

export const ListCredit = () => {
  const classes = useStyles();
  const filters = useSelector((state) => state.frontCreditoFilters);
  const dispatch = useDispatch();

  const { pageLimit, setPageLimit } = useContext(Context);

  const [updated, setUpdated] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);
  const [loadFilter, setLoadFilter] = useState(false);
  const [totalElements, setTotalElements] = useState(0);
  const [orderByColumn, setOrderByColumn] = useState("dataAtualizacao");
  const [orderDirection, setOrderDirection] = useState("DESC");
  const [propostas, setPropostas] = useState([]);

  useEffect(() => {
    loadData();
  }, [filters, loadFilter, pageLimit, orderByColumn, orderDirection]);

  const loadData = () => {
    if (!isLoading) {
      setIsLoading(true);
      setPropostas([]);
      setTotalElements(0);
      setLoadFilter(false);

      getPropostas(filters, pageLimit, orderByColumn, orderDirection)
        .then((response) => {
          const {
            data: { content, totalElements },
          } = response;
          setPropostas(content);
          setTotalElements(totalElements);
        })
        .catch(() => {
          toast.error("Erro ao buscar as propostas.");
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const handleChangePageSize = (item) => {
    setPageLimit(item.id);
  };

  const handleChangePage = (p, newPage) => {
    dispatch(setStatePage(newPage));
  };

  const setFilters = (payload) => {
    dispatch(setStateFilters(payload));
  };

  return (
    <>
      <SearchComponent
        key={filters.key}
        filters={filters}
        setFilters={setFilters}
        isLoading={isLoading}
        setLoadFilter={setLoadFilter}
      />
      <S.CardHeader>
        <span>
          {`${totalElements} proposta${
            totalElements > 1 ? "s" : ""
          } cadastrada${totalElements > 1 ? "s" : ""}`}
        </span>
        {totalElements > 0 && (
          <span className="border">Selecione a proposta desejada</span>
        )}
      </S.CardHeader>

      {isLoading ? (
        <SkeletonListItem />
      ) : (
        <S.TableWrapper>
          <TableComponent
            propostas={propostas}
            updateTable={loadData}
            orderBy={orderByColumn}
            setOrderBy={setOrderByColumn}
            sortDirection={orderDirection}
            setSortDirection={setOrderDirection}
          />
        </S.TableWrapper>
      )}
      {!isLoading && (
        <S.RodaPe>
          <S.SelectPaginacaoWrapper>
            <S.SelectContainer>
              <BorderForSelectNumberOfRecords
                selected={0}
                handleSearch={handleChangePageSize}
                initialValue={pageLimit}
              />
            </S.SelectContainer>
          </S.SelectPaginacaoWrapper>
          <TablePagination
            component="div"
            classes={{
              toolbar: classes.toolbar,
              caption: classes.caption,
            }}
            count={totalElements}
            page={filters.page || 0}
            labelDisplayedRows={({ from, to, count }) =>
              `${from} - ${to} de ${count}`
            }
            onPageChange={handleChangePage}
            rowsPerPageOptions={[]}
            rowsPerPage={pageLimit}
          />
        </S.RodaPe>
      )}
      <GoTopoButtonWrapper>
        <Button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          height="32px"
          leftIcon={IoChevronUp}
        >
          Topo
        </Button>
      </GoTopoButtonWrapper>
    </>
  );
};

export default ListCredit;
